/* eslint-disable max-len */
import { useState, useEffect } from 'react';

/**
 * Hook to manage the checkboxes column state.
 *
 * @param {Object} options
 * @param {Array<{ id: string }>} options.results — Full dataset; used to reset selection when data changes and as the default scope for "select all".
 * @param {() => Array<{ id: string }>} [options.getRowsForSelectAll] — When set, "select all" uses these rows (e.g. filtered/visible rows) instead of `results`.
 */
const useCheckboxSelection = ({ results, getRowsForSelectAll }) => {
  const [selectedIds, setSelectedIds] = useState(new Set());
  useEffect(() => {
    setSelectedIds(new Set());
  }, [results]);

  const handleSelectDeSelectAllRows = (event) => {
    event.persist();
    const checked = event.target.checked;
    if (checked) {
      const rowsForSelectAll = getRowsForSelectAll
        ? getRowsForSelectAll()
        : results;
      setSelectedIds(new Set(rowsForSelectAll.map((row) => row.id)));
    }
    if (!checked) {
      setSelectedIds(new Set());
    }
  };

  const handleSelectRow = (row) => {
    const id = row.id;
    setSelectedIds((prev) => {
      const newSelected = new Set(prev);
      if (newSelected.has(id)) {
        newSelected.delete(id);
      } else {
        newSelected.add(id);
      }
      return newSelected;
    });
  };

  const isAtLeastOneRowSelected = selectedIds.size > 0;

  return {
    selectedIds,
    handleSelectDeSelectAllRows,
    handleSelectRow,
    isAtLeastOneRowSelected,
  };
};

export default useCheckboxSelection;
